import { Tag, Tooltip } from 'antd'
import { StatusDropdown } from 'components/ui/StatusDropdown/StatusDropdown'
import { appSelectors } from 'store/app'
import { EProductStatus } from 'models/product'
import {
  BLOCKED_PRODUCT_HINT,
  getProductStatusItemsWithManualToggle,
  productTags
} from 'shared/constants/product'
import { useAppSelector } from 'shared/hooks/useReduxHooks'
import { ERoles } from 'models/auth'
import styles from '../ProductForm.module.scss'

interface IProductStatusProps {
  activeStatus: EProductStatus | undefined
  className?: string
  onStatusClick: (statusKey: string) => void
}

export const ProductStatus: React.FC<IProductStatusProps> = ({
  activeStatus,
  onStatusClick,
  className
}) => {
  const role = useAppSelector(appSelectors.selectRole)

  if (!activeStatus) {
    return null
  }

  const items = getProductStatusItemsWithManualToggle(
    activeStatus,
    role as ERoles
  )

  if (!items.length) {
    const statusTag = (
      <Tag
        color={productTags[activeStatus].color}
        className={`${styles.status} ${className}`}
      >
        {productTags[activeStatus].label}
      </Tag>
    )

    // продавцу тег «Заблокирован» недоступен для клика — только подсказка почему
    if (activeStatus === EProductStatus.BLOCKED) {
      return <Tooltip title={BLOCKED_PRODUCT_HINT}>{statusTag}</Tooltip>
    }

    return statusTag
  }

  return (
    <StatusDropdown
      items={items}
      label={productTags[activeStatus].label}
      color={productTags[activeStatus].color}
      onClick={(e) => onStatusClick(e.key)}
      className={`${styles.status} ${className}`}
    />
  )
}
